import React from 'react';
import {Text} from '@wix/wix-ui-tpa/cssVars';
import {useEnvironment, useTranslation} from '@wix/yoshi-flow-editor';
import {SubscriptionInfoModel} from '../../../../../../domain/models/LineItems/SubscriptionInfo.model';
import {SubscriptionFrequency} from '../../../../../../domain/models/LineItems/SubscriptionSettings.model';
import {classes} from './ItemSubscription.st.css';
import {getSubscriptionDuration, getFrequencyText} from '../../partials/ItemDetails/mapLineItemToDetails';

export interface SubscriptionProps {
  dataHook: string;
  subscription: SubscriptionInfoModel;
}

export enum SubscriptionDataHook {
  Name = 'SubscriptionDataHook.Name',
  Duration = 'SubscriptionDataHook.Duration',
  StartDate = 'SubscriptionDataHook.StartDate',
  FreeTrial = 'SubscriptionDataHook.FreeTrial',
}

export const ItemSubscription = ({subscription, dataHook}: SubscriptionProps) => {
  const {language} = useEnvironment();
  const {t} = useTranslation();
  const startDate = subscription.subscriptionSettings.startDate
    ? new Date(subscription.subscriptionSettings.startDate).toLocaleDateString(language, {
        year: 'numeric',
        month: 'short',
        day: '2-digit',
      })
    : undefined;

  const shouldDisplayFreeTrial =
    subscription.subscriptionSettings.freeTrialPeriod?.interval > 0 &&
    subscription.subscriptionSettings.freeTrialPeriod.frequency !== SubscriptionFrequency.UNDEFINED;

  const duration = getSubscriptionDuration(subscription.subscriptionSettings, t);
  const freeTrialFrequency = shouldDisplayFreeTrial
    ? getFrequencyText({
        frequency: subscription.subscriptionSettings.freeTrialPeriod.frequency,
        cycles: subscription.subscriptionSettings.freeTrialPeriod.interval,
        t,
      })
    : '';

  return (
    <div className={classes.root} data-hook={dataHook}>
      {subscription.title && (
        <Text data-hook={SubscriptionDataHook.Name} className={classes.text}>
          {subscription.title}
        </Text>
      )}
      <Text data-hook={SubscriptionDataHook.Duration} className={classes.text}>
        {duration}
      </Text>
      {startDate && (
        <Text data-hook={SubscriptionDataHook.StartDate} className={classes.text}>
          {t('cart.pricingPlans.startDate.label', {date: startDate})}
        </Text>
      )}
      {shouldDisplayFreeTrial && (
        <Text data-hook={SubscriptionDataHook.FreeTrial} className={classes.text}>
          {t('cart.pricingPlans.freeTrial.label', {
            number: subscription.subscriptionSettings.freeTrialPeriod.interval,
            frequency: freeTrialFrequency,
          })}
        </Text>
      )}
    </div>
  );
};
